"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getRadiumStyleState = function getRadiumStyleState(component) {
  return component._lastRadiumState || component.state && component.state._radiumStyleState || {};
};

exports.default = getRadiumStyleState;


//////////////////
// WEBPACK FOOTER
// ./~/radium/lib/get-radium-style-state.js
// module id = 887
// module chunks = 0